import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IFatura,
  IGetFaturasQueryParams,
  IListaPaginada
} from 'src/app/interfaces';
import { IFechamento } from 'src/app/interfaces/fatura/IFechamento';
import { IGetFechamentosQueryParams } from 'src/app/interfaces/fatura/IGetFechamentoQueryParams';

@Injectable({
  providedIn: 'root'
})
export class FaturaService {
  private readonly baseURL = '/Fatura';
  constructor(private httpClient: HttpClient) {}

  getFaturas(body: IGetFaturasQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IFatura>>>(
      this.baseURL,
      body
    );
  }
  getFechamento(body: IGetFechamentosQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IFechamento>>>(
      `${this.baseURL}/Fechamentos`,
      body
    );
  }
  getDownloadPDFFechamento(body: IGetFechamentosQueryParams) {
    return this.httpClient.post<IApiResponse<string>>(
      `${this.baseURL}/exportarPDFFechamento`,
      body
    );
  }
  getDownloadCSVFechamento(body: IGetFechamentosQueryParams) {
    return this.httpClient.post<IApiResponse<string>>(
      `${this.baseURL}/exportarCSVFechamento`,
      body
    );
  }
}
